export default {
  ASSIGN: 'assign', // 상담할당 상태의 방
  ACTIVE: 'active', // active상태의 방
  TRANSFER: 'transfer' // 이관상태의 방
}



// WEBPACK FOOTER //
// ./src/components/operation/enums/chatRoomStatus.js